var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"custom-control custom-radio custom-control-inline"},[_c('input',{staticClass:"custom-control-input",attrs:{"type":"radio","group":_vm.group,"id":_vm.id,"name":_vm.name},domProps:{"value":_vm.value,"checked":_vm.checked}}),_vm._v(" "),_c('label',{staticClass:"custom-control-label",attrs:{"for":_vm.id}},[_vm._v(_vm._s(_vm.text))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-744c7b46","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-components/input-radio.vue
// module id = 1566
// module chunks = 0